var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.424 6.477 5.123 1.14a3 3 0 0 0-3.06-.11A2.96 2.96 0 0 0 .5 3.665v10.673c0 1.098.599 2.107 1.563 2.634.457.249.95.373 1.441.373.561 0 1.119-.162 1.619-.483l8.301-5.337A2.99 2.99 0 0 0 14.802 9a2.99 2.99 0 0 0-1.378-2.523",
    clipRule: "evenodd"
  })));
};
export default SvgPlay;